import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks/StoreHooks";
import { projectDetailsCalculationsPayload } from "../../store/model/jetlift/jetlift";

const useJetliftCalculationFacade = () => {
    const dispatch = useAppDispatch();
    const { ID, caseID } = useParams();

    const loadJetliftProjectDetails = () => {
        const projectId = ID?.split("projectID=")?.[1];
        const caseId = caseID?.split("caseID=")?.[1];
        const payload = {
            id: (caseId !== projectId && caseId !== undefined) ? caseId : projectId,
            templateid: ""
        };
        getJetliftCalculations(payload);
    };

    const loadJetlifttemplateCalculations = () => {
        const templateId: string = ID?.split("templateID=")?.[1] ?? "";
        const payload: projectDetailsCalculationsPayload = {
            id: "",
            templateId: templateId,
            unitSystem: 0,
        }
        getJetliftTemplateCalculations(payload);
    };

    const getJetliftCalculations = (payload: projectDetailsCalculationsPayload) => {
        return dispatch({ type: "jetlift/calculations/getProjectDetails", payload: { id: payload?.id ?? "", unitSystem: payload?.unitSystem } });
    };

    const getJetliftTemplateCalculations = (payload: projectDetailsCalculationsPayload) => {
        return dispatch({ type: "jetlift/calculations/fetchTemplateCalculations", payload: { id: payload?.id ?? "", templateId: payload?.templateId ?? "", unitSystem: payload?.unitSystem } })
    };

    const SaveJetliftProject = () => {
        const projectId = ID?.split("projectID=")?.[1];
        const caseId = caseID?.split("caseID=")?.[1];
        return dispatch({ type: "jetlift/calculations/saveJetliftProject", payload: { id: (caseId !== projectId && caseId !== undefined) ? caseId : projectId } });
    };

    const CopyJetliftProject = (payload: {
        ProjectID: string;
        ProjectName: string;
        CaseName: string;
        DisplayCaseName: string;
        IsCaseLevel: boolean;
        customerCnxId: number;
        operatorContact: string;
        companyName: string;
        parentId: string;
        CaseProjectId: string;
    }) => {
        return dispatch({ type: "jetlift/calculations/copyJetliftProject", payload });
    };

    return {
        loadJetliftProjectDetails,
        loadJetlifttemplateCalculations,
        getJetliftCalculations,
        getJetliftTemplateCalculations,
        SaveJetliftProject,
        CopyJetliftProject,
    }

};

export default useJetliftCalculationFacade;